export default "__VITE_ASSET__CTgGB6x5__"